import { useRouter } from 'next/router'

import bootcampAnalytics from '~/analytics/bootcamp/bootcampAnalytics'

import { BootcampPageUrlParamsType } from '../types/bootcamp.types'

export default function useTrackHelpToggle(): (isOpen: boolean) => void {
  const router = useRouter()
  const { query } = router
  const { action, key, level, moduleKey, subtopic } = query as unknown as BootcampPageUrlParamsType

  const onHelpToggle = (isOpen: boolean): void => {
    bootcampAnalytics.logClickHelpButton({
      category: subtopic,
      subject: key,
      bootcamp: moduleKey,
      level,
      bootcamp_page_type: action,
      status: isOpen ? 'open' : 'close',
    })
  }

  return onHelpToggle
}
